import { useState } from "react";
export function useAddToBag(props) {
    var _a = useState(false), isAddingToBag = _a[0], setAddingToBag = _a[1];
    var addToBag = function (config) {
        if (!window.ONNIT || !window.ONNIT.cart) {
            throw new Error("ONNIT.cart is undefined");
        }
        setAddingToBag(true);
        window.ONNIT.cart
            .addProducts(Array.isArray(config) ? config : [config], undefined, undefined, props === null || props === void 0 ? void 0 : props.listName)
            .then(function () {
            window.ONNIT && window.ONNIT.cart && window.ONNIT.cart.openDrawer();
            (props === null || props === void 0 ? void 0 : props.onSuccess) && props.onSuccess();
        })
            .catch(function (error) {
            console.error("Failed to add product to cart.", error);
            (props === null || props === void 0 ? void 0 : props.onError) && props.onError(error);
        })
            .finally(function () { return setAddingToBag(false); });
    };
    return {
        addToBag: addToBag,
        isAddingToBag: isAddingToBag,
    };
}
//# sourceMappingURL=useAddToBag.js.map